import React from 'react';

const RestartIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
            <path
                fill="#fff"
                d="M6.402 27.548C6.402 36.649 14.438 44 24.412 44c9.955 0 17.99-7.35 17.99-16.452 0-1.222-.94-2.08-2.258-2.08-1.3 0-2.18.858-2.18 2.08 0 6.858-6.036 12.385-13.552 12.385-7.515 0-13.552-5.527-13.552-12.385 0-6.95 5.937-12.422 13.432-12.422 1.16 0 2.22.073 3.139.237l-5.038 4.56c-.4.365-.62.803-.62 1.332 0 1.13.94 1.988 2.16 1.988.62 0 1.139-.182 1.519-.547l8.195-7.533c.46-.438.68-.93.68-1.496 0-.547-.24-1.076-.68-1.477l-8.195-7.588c-.4-.401-.9-.602-1.52-.602-1.219 0-2.158.912-2.158 2.025 0 .547.22.985.6 1.368l4.457 4.012c-.76-.146-1.64-.218-2.539-.218-9.954 0-17.89 7.259-17.89 16.36"
            />
        </svg>
    );
};

export default RestartIcon;
